import { t } from '@lingui/macro';

import { noddiAsync, URLKeys } from 'noddi-async';
import { tracking } from 'noddi-provider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorPageWithTranslations } from '../../components/ErrorPageWithTrans';
import { WheelChangeImageCard } from '../../components/Home/WheelChangeImageCard';
import { NoddiLoadingScreenWithTrans } from '../../components/NoddiLoadingScreenWithTrans';
import { RecallContentWrapper } from './ContentWrapper';
import { RecallCard } from './RecallCard';

export const Recall = () => {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <ErrorPageWithTranslations />;
  }

  return <RecallContent slug={slug} />;
};

const RecallContent = ({ slug }: { slug: string }) => {
  const {
    data: booking,
    isPending: isBookingPending,
    error: bookingError
  } = noddiAsync.useGet({
    type: URLKeys.getRecallBooking,
    input: { slug }
  });

  useEffect(() => {
    if (booking) {
      tracking.track('autoRecallViewed');
    }
  }, [booking]);

  if (isBookingPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (bookingError?.response?.data.errors.find((error) => error.code === 'booking_is_not_recall_proposal')) {
    return (
      <RecallContentWrapper
        title={t`Hello again`}
        subtitle={t`Your suggested booking is no longer available, feel free to create a new booking`}
        hideBackButton
      >
        <WheelChangeImageCard
          cardText={t`Tell us where your car is parked. We'll come to you, so you can spend your time on other things`}
        />
      </RecallContentWrapper>
    );
  }

  if (bookingError) {
    return <ErrorPageWithTranslations apiError={bookingError} />;
  }

  return (
    <RecallContentWrapper
      subtitle={`${t`It's time for your tire change again! We've reserved a spot for you`}`}
      hideBackButton
      title={`${t`Hi`} ${booking.userFirstName}!`}
    >
      <RecallCard booking={booking} slug={slug} />
    </RecallContentWrapper>
  );
};
